import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'

import {
  closeDeleteWorkspacePopup,
} from '@SiteModules/Popup/actions'

import {
  deleteWorkspaces
} from '@SiteModules/Workspace/actions'

import {
  getEditingWorkspaceIds,
  getFirstEditingWorkspaceName,
} from '@SiteModules/Popup/selectors'

import './DeleteWorkspacePopup.scss'

interface DeleteWorkspacePopupProps {
  resetOpenedWorkspace(): void
}

const DeleteWorkspacePopup: React.FC<DeleteWorkspacePopupProps> = props => {
  const dispatch = useDispatch()

  const editingWorkspaceIds = useSelector(getEditingWorkspaceIds)
  const workspaceName = useSelector(getFirstEditingWorkspaceName)

  const numberOfWorkspaces = editingWorkspaceIds.length
  const isForOneWorkspace = numberOfWorkspaces === 1

  const handleCancel = () => {
    dispatch(closeDeleteWorkspacePopup())
  }

  const handleDelete = () => {
    dispatch(deleteWorkspaces({ workspaceIds: editingWorkspaceIds }))
    props.resetOpenedWorkspace()
    dispatch(closeDeleteWorkspacePopup())
  }

  return (
    <Popup
      className="DeleteWorkspacePopup"
      closePopup={handleCancel}
      zIndex={200000}
    >
      <div className="DeleteWorkspacePopup__header">
        {isForOneWorkspace ? `Delete workspace "${workspaceName}"?` : `Delete ${numberOfWorkspaces} workspaces?`}
      </div>
      <div className="DeleteWorkspacePopup__description">
        This action is permanent. It will delete this workspace and all associated items: projects, assets, vocabularies... This cannot be undone.
      </div>
      <div className="DeleteWorkspacePopup__button-wrapper">
        <Button
          styleType="gray-subtle"
          size="small"
          caption="Delete permanently"
          onClick={handleDelete}
        />
        <Button
          styleType="brand"
          size="small"
          caption="Cancel"
          onClick={handleCancel}
        />
      </div>
    </Popup>
  )
}

export default DeleteWorkspacePopup
